import { OrderItemResponse } from '@/types/order-type';
import { money } from './receipt-utils';

interface ReceiptItemsProps {
  items: OrderItemResponse[];
  showPrices?: boolean;
}

/**
 * Print-optimised table of receipt items.
 * - No dividers between rows (paper-saving).
 * - Renders a separator between the item table and the section below.
 */
export function ReceiptItems({
  items,
  showPrices = true,
}: ReceiptItemsProps) {
  return (
    <div className="receipt-items text-xs">
      <div className="px-4 py-1">
        <table className="receipt-table w-full border-collapse border-spacing-0">
          <thead>
            <tr className="border-b border-black text-left">
              <th className="py-1 pb-2 w-8 border-r border-black pr-3">No.</th>
              <th className="py-1 pb-2"><div className="ml-2">Item</div></th>
              <th className="py-1 pb-2 text-center w-10">Qty</th>
              {/* {showPrices && (
                <>
                  <th className="py-1 pb-2 text-right w-16">Price</th>
                  <th className="py-1 pb-2 text-right w-20">Total</th>
                </>
              )} */}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <ReceiptItemRow
                key={item.id}
                item={item}
                index={index}
                showPrices={showPrices}
              />
            ))}
          </tbody>
        </table>
      </div>
      {/* Separator between the last item row and the totals section */}
      <div className="border-t border-black"></div>
    </div>
  );
}

type ReceiptItemRowProps = {
  item: OrderItemResponse;
  index: number;
  showPrices: boolean;
};

// function getUnitPrice(item: OrderItemResponse): number {
//   if (typeof item.price === 'number') {
//     return item.price;
//   }

//   return parseFloat(item.price ?? '0');
// }

// function getLineTotal(item: OrderItemResponse): number {
//   const unitPrice = getUnitPrice(item);
//   return unitPrice * Number(item.quantity ?? 0);
// }

function ReceiptItemRow({ item, index, showPrices }: ReceiptItemRowProps) {
  // const unitPrice = getUnitPrice(item);
  // const lineTotal = getLineTotal(item);

  return (
    <tr className="receipt-item-row font-bold">
      <td className="pr-3 text-center border-r border-black">
        {index + 1}
      </td>
      <td className="pr-2">
        <div className="ml-2">{item.variantName}</div>
      </td>
      <td className="text-center">
        {item.quantity}
      </td>
      {/* {showPrices && (
        <>
          <td className="pt-1 text-right">
            {money(unitPrice)}
          </td>
          <td className="pt-1 text-right">
            {money(lineTotal)}
          </td>
        </>
      )} */}
    </tr>
  );
}
